"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLocalStorageStateBase_1 = require("./useLocalStorageStateBase");
function createLocalStorageStateHook(key, defaultValue) {
    const updates = [];
    return function useLocalStorageStateHook() {
        const [value, setValue, isPersistent] = useLocalStorageStateBase_1.default(key, defaultValue);
        const updateValue = react_1.useMemo(() => {
            const fn = (newValue) => {
                for (const update of updates) {
                    update(newValue);
                }
            };
            fn.reset = () => {
                for (const update of updates) {
                    update.reset();
                }
            };
            return fn;
        }, []);
        react_1.useEffect(() => {
            updates.push(setValue);
            return () => void updates.splice(updates.indexOf(setValue), 1);
        }, [setValue]);
        return [value, updateValue, isPersistent];
    };
}
exports.default = createLocalStorageStateHook;
